<template>

	<div class="col">
		<p class="label-text">
			<slot name="label"></slot>
		</p>
		<p>
			<slot name="info"></slot>
		</p>
	</div>

</template>
<script>
	
	import Vue from 'vue';
    export default {
    	components:{

		},
		data: () => ({
	
		})
	}

</script>